import { useRepo, Model } from "pinia-orm";

export default class Client extends Model {
  static name = "Client";
  static entity = "clients";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      code: this.attr(""),
      label: this.attr(""),
      name: this.attr(""),
      postcode: this.attr(""),
      city: this.attr(""),
      address: this.attr(""),
      telephone: this.attr(""),
      mobile: this.attr(""),
      email: this.attr(""),
      chronorapso: this.attr(""),
      contactCompany: this.attr(""),
      contactFirstName: this.attr(""),
      contactLastName: this.attr(""),
      contactRole: this.attr(""),
      contactPostcode: this.attr(""),
      contactCity: this.attr(""),
      contactAddress: this.attr(""),
      contactTelephone: this.attr(""),
      contactMobile: this.attr(""),
      contactEmail: this.attr(""),
      decisionCenterCode: this.attr(""),
      decisionCenterLabel: this.attr(""),
    };
  }

  static createFromListerData(data) {
    const ClientRepo = useRepo(this);
    ClientRepo.save({
      uuid: data.clientUuid,
      label: data.rapsoClientLabel || data.clientLabel,
      code: data.clientCode,
    });
  }
}
